// We don't know the type of the row data, so we use any
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { SortDirection, SortingFn } from '@tanstack/react-table'
import { Dot, MoveDown, MoveUp } from 'lucide-react'

import { iconStroke } from '@lib/iconProps'

/**
 * Numeric sort (handles strings & numbers).
 */
export const sortNumber: SortingFn<any> = (rowA, rowB, columnId) => {
  const a = Number(rowA.getValue<any>(columnId))
  const b = Number(rowB.getValue<any>(columnId))

  return a - b
}

const sortProps = {
  strokeWidth: iconStroke.bold,
  className: 'min-w-3 min-h-3 !size-3 text-muted-foreground',
}
export const getSortingIcon = (isSorted: false | SortDirection, canSort: boolean) => {
  if (isSorted === 'asc') return <MoveUp {...sortProps} />
  if (isSorted === 'desc') return <MoveDown {...sortProps} />
  if (canSort) return <Dot {...sortProps} />

  return ''
}
